import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useAdminGetAllUsers } from './generated/endpoint';
import { AdminGetAllUsersParams } from './generated/models';
import { ErrorType, useCustomAxios } from './mutator/custom-instance';

export interface AllUserResponse {
    id: number;
    email: string;
    name: string;
    role: string;
    status: string;
}

export interface PaginatedAllUserResponse {
    users: AllUserResponse[];
    totalUserCount: number;
}

export interface GetAllUsersParams {
    skip?: number;
    take?: number;
    searchString?: string;
    userStatus?: number;
}

export const getGetAllUsersQueryKey = (params: GetAllUsersParams) =>
    ['/v1/User/all', params] as const;

export const useGetUsersForCurrentTenant = (params: AdminGetAllUsersParams) =>
    useAdminGetAllUsers(params);

export const useGetAllUsers = (
    params: GetAllUsersParams,
    options?: UseQueryOptions<PaginatedAllUserResponse, ErrorType<void>>
) => {
    const customAxios = useCustomAxios<PaginatedAllUserResponse>();

    return useQuery<PaginatedAllUserResponse, ErrorType<void>>({
        queryKey: getGetAllUsersQueryKey(params),
        queryFn: () =>
            customAxios({
                url: '/v1/User/all',
                method: 'GET',
                params,
            }),
        ...options,
    });
};
